module.exports = __webpack_public_path__ + "img/forgot-password-v2.73988996.svg";